import React from 'react';

/**
 * Simple wrapper for Ionicons
 * Usage: <Icon name="checkmark-circle" style={{fontSize: 20, color: '#00cc66'}} />
 */
export default function Icon({ name, style, ...props }) {
  return <ion-icon name={name} style={style} {...props}></ion-icon>;
}
